import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useUserContext } from "../Context/UserContext";
import { loginUrlForReturnPath } from "./authRouting";

export default function RequireAuthenticatedRoute({ children }: { children: React.ReactNode }) {
  const { user, isAuthLoading } = useUserContext();
  const location = useLocation();
  if (isAuthLoading) return <div className="reviewed-loading" role="status">Loading your workspace…</div>;
  if (!user) return <Navigate replace to={loginUrlForReturnPath(`${location.pathname}${location.search}${location.hash}`)} />;
  return <>{children}</>;
}
